import { NgModule } from '@angular/core';
import { AppMaterialModule } from '../appMaterial/app-material.module';
import { FlexLayoutModule } from '@angular/flex-layout';
import { PhonePurchaseErrorComponent } from './phone-purchase-error.component';
import { PhonePurchaseErrorService } from './phone-purchase-error-service';

@NgModule({
    imports: [AppMaterialModule, FlexLayoutModule],
    exports: [PhonePurchaseErrorComponent],
    declarations: [PhonePurchaseErrorComponent],
    providers: [PhonePurchaseErrorService]
})
export class PhonePurchaseErrorModule {}
